// extracted by mini-css-extract-plugin
export default {"container":"tables_container__Dr+mB","searchBar":"tables_searchBar__QKj-s","rightMargin":"tables_rightMargin__3MKux"};